import React from "react";
import { TextField, Stack } from "@mui/material";
import MultiInput from "./MultiInput";
import FileUploadPreview from "./FileUploadPreview";

const MetaFields = ({
  getFieldValue,
  handleChange,
  handleFileChange,
  errors = {},
}) => {
  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        label="Meta Title"
        name="metafields.title"
        value={getFieldValue("metafields.title")}
        onChange={handleChange}
        error={!!errors["metafields.title"]}
        helperText={errors["metafields.title"]}
      />
      <TextField
        fullWidth
        label="Meta Description"
        name="metafields.description"
        value={getFieldValue("metafields.description")}
        onChange={handleChange}
        multiline
        minRows={2}
        error={!!errors["metafields.description"]}
        helperText={errors["metafields.description"]}
      />
      <TextField
        fullWidth
        label="Canonical URL"
        name="metafields.canonical"
        value={getFieldValue("metafields.canonical")}
        onChange={handleChange}
        error={!!errors["metafields.canonical"]}
        helperText={errors["metafields.canonical"]}
      />
      <FileUploadPreview
        label="Featured Image"
        id="featuredImage"
        fileField="featuredImage"
        acceptedTypes="image/*"
        allowUrl
        urlField="metafields.image"
        getFieldValue={getFieldValue}
        onFileChange={handleFileChange}
        onUrlChange={handleChange}
        errors={errors}
      />
      <MultiInput
        initialValues={getFieldValue("metafields.tags")}
        onChange={handleChange}
        label="Tags"
        name="metafields.tags"
        errors={errors}
      />
      <MultiInput
        initialValues={getFieldValue("metafields.keywords")}
        onChange={handleChange}
        label="Keywords"
        name="metafields.keywords"
        errors={errors}
      />
    </Stack>
  );
};

export default MetaFields;
